import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MobileItem from "../../../../../../components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "../../../../../../components/WMS/Mobile/ThumbnailAndNotification";
import NumberCircle from "../../../../../../components/icons/NumberCircle";
import Badge from "../../../../../../components/Badge";
import {WMSContext} from "../../../../context/WMSContext";

import RemoveFromTrolleyAction from "components/WMS/Mobile/WmsItemList/components/RemoveFromTrolleyAction";
import WmsItemInformationDrawer from "components/WMS/Mobile/WmsItemList/components/WmsItemInformationDrawer";

DisplayItemList.propTypes = {
    currentTrolley: PropTypes.object.isRequired,
    refreshTrolley: PropTypes.func
};

function DisplayItemList({currentTrolley, refreshTrolley = () => {}}) {
    const [selectedWmsItem, setSelectedWmsItem] = useState(null);

    const {currentMember} = useContext(WMSContext)

    const handleCloseItemInformationDrawer = () => {
        setSelectedWmsItem(null)
    }

    useEffect(() => {
        handleCloseItemInformationDrawer()
    }, [currentTrolley]);

    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {currentTrolley.wmsItems.map((item) => {
                return (
                    <MobileItem key={item.id} onClick={() => setSelectedWmsItem(item)}>
                        <MobileItem.LeftSide
                            title={item.lineItem.name}
                            subtitle={
                                <>
                                    {item.lineItem.options.map(option => option.value[`${currentMember?.locale}`]).join(' · ')}
                                </>
                            }
                            underTitle={
                                <Badge
                                    isBold={false}
                                    label={<span>{item.barcode}</span>}
                                    color={"info"}
                                    size={"large"}
                                    rounded
                                />
                            }
                        >
                            <ThumbnailAndNotification
                                link={item.lineItem.pictures[0]}
                                alt={"Wishibam logo"}>
                                <NumberCircle number={item.count}/>
                            </ThumbnailAndNotification>
                        </MobileItem.LeftSide>
                        <MobileItem.RightSide>
                            <Badge color={'info'}
                                   rounded
                                   isBold={false}
                                   size={'large'}
                            >
                                {item.shipmentType}
                            </Badge>
                        </MobileItem.RightSide>
                    </MobileItem>
                )
            })}
            <WmsItemInformationDrawer
                selectedWmsItem={selectedWmsItem}
                handleClose={handleCloseItemInformationDrawer}
            >
                <RemoveFromTrolleyAction
                    selectedWmsItem={selectedWmsItem}
                    onRemoveFromTrolley={() => refreshTrolley()}
                    handleCloseDrawer={handleCloseItemInformationDrawer}
                />
            </WmsItemInformationDrawer>
        </div>
    );
}

export default DisplayItemList;
